
export function unpack (objarr: Array<any>, key: string) {
  return objarr.map( obj => obj[key] ) 
}

export function fill (length: number, value=1) {
  return new Array(length).fill(value) 
}

export function unique (arr: Array<any>) {
  return arr.filter( (v, i, a) => a.indexOf(v) === i) 
}

export function sort (it: Iterable<any>) {
  return Array.from(it).sort()
}

export function equalSets (a: Set<any>, b: Set<any>) {
  return a.size === b.size && Array.from(a).every(value => b.has(value))
}

export function equalArrays (a: Array<any>, b: Array<any>) { // also checks for same order!!
  return a.length === b.length && a.every((value, index) => b[index]==value)
}

export function comparator(a: string, b: string) { 
  return a.localeCompare(b, 'en', {sensitivity: 'base', ignorePunctuation: true})
} 

export function seq (to: number, from=0, by=1) { 
  const res = []
  for (let i=from; i<to; i+=by) { 
    res.push(i) }
  return res 
}

/**
 * convert a long text string of tsv format into an array of javascript objects
 * 
 * @param {string} tsv The tsv formatted text string
 * @return {Map<string, string>[]} an array of maps (one per row) with header names as keys 
 */
export function tsv2objects(tsv: string): Map<string, string>[] {
  const lines = tsv.split(/\r?\n/)
  const header =  lines.shift()?.split('\t')
  if (!header) {
    return []
  } else {
    return lines.filter( line => line.length > 0 ).map(
      (line) => {
        return line.split('\t').reduce(
          (acc, cur, idx) => acc.set(header[idx], cur),
          new Map<string, string>())
      }
    )
  }
}

export class MapWithDefault<K, V> extends Map<K, V> {
  constructor(public defaultValue: () => V) {
    super()
  }

  get(key: K) {
    if (! this.has(key))
      this.set(key, this.defaultValue())
    return super.get(key) as V
  }
}